import React, { FC } from "react";

import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "@readai/pulse/components/Stack";

export const AppContainer = styled<FC<StackProps>>((props) => (
  <Stack variant="center" {...props} />
))(({ theme }) => ({
  width: "100vw",
  height: "100vh",
  minHeight: "100vh",
  background: theme.palette.gradients.light,
  [theme.breakpoints.up("lg")]: {
    maxHeight: "100vh",
  },
}));
